import React, { useState } from 'react';
import { Text } from '@fluentui/react-components';
import { ChevronRight20Regular, ChevronDown20Regular } from '@fluentui/react-icons';
import { COLLAPSIBLE_STYLES, SECTION_COLORS } from '../constants';

interface CollapsibleSectionProps {
  title: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  variant?: 'default' | 'neutral' | 'create';
}

/**
 * Reusable collapsible section component with color variants
 * Used in deployment summary dialogs
 */
export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({ 
  title,
  icon,
  defaultOpen = true,
  children,
  variant = 'default',
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  // Color coding based on variant
  const colors = SECTION_COLORS[variant];
  
  return (
    <div style={COLLAPSIBLE_STYLES.wrapper(colors.border)}>
      <div 
        onClick={() => setIsOpen(!isOpen)}
        style={COLLAPSIBLE_STYLES.header(colors.bg)}
      >
        {isOpen ? <ChevronDown20Regular style={COLLAPSIBLE_STYLES.chevron} /> : <ChevronRight20Regular style={COLLAPSIBLE_STYLES.chevron} />}
        {icon}
        <Text style={COLLAPSIBLE_STYLES.headerTitle}>{title}</Text>
      </div>
      {isOpen && <div style={COLLAPSIBLE_STYLES.body(colors.content)}>{children}</div>}
    </div>
  );
};
